import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoomServiceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"room_service"}/>
}
